import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Bíceps Braquial
// 10 Básicas + 10 Generales + 10 Complejas

export const bicepsBraquialQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10001,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas cabezas tiene el músculo bíceps braquial?",
    options: ["Una", "Dos", "Tres", "Cuatro"],
    correctAnswer: 1,
    explanation: "El bíceps braquial tiene dos cabezas: la cabeza larga que se origina en el tubérculo supraglenoideo de la escápula, y la cabeza corta que se origina en la apófisis coracoides. Ambas se unen para formar el vientre muscular."
  },
  
  {
    id: 10002,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el tendón del bíceps braquial?",
    options: [
      "Olécranon del cúbito",
      "Tuberosidad del radio",
      "Apófisis estiloides del radio",
      "Epicóndilo medial del húmero"
    ],
    correctAnswer: 1,
    explanation: "El tendón distal del bíceps braquial se inserta en la tuberosidad del radio. Esta inserción es clave para su función de supinación del antebrazo y flexión del codo."
  },
  
  {
    id: 10003,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal del bíceps braquial?",
    options: [
      "Extensión del codo",
      "Pronación del antebrazo",
      "Flexión del codo y supinación del antebrazo",
      "Abducción del hombro"
    ],
    correctAnswer: 2,
    explanation: "Las acciones principales del bíceps braquial son la flexión del codo y la supinación del antebrazo (girar la palma hacia arriba). La supinación es más efectiva con el codo flexionado a 90 grados."
  },
  
  {
    id: 10004,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al bíceps braquial?",
    options: [
      "Nervio radial",
      "Nervio mediano",
      "Nervio musculocutáneo",
      "Nervio ulnar"
    ],
    correctAnswer: 2,
    explanation: "El nervio musculocutáneo (C5-C6) inerva al bíceps braquial. Este nervio se origina del fascículo lateral del plexo braquial y atraviesa el músculo coracobraquial antes de inervar el bíceps y el braquial."
  },
  
  {
    id: 10005,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria principal irriga al bíceps braquial?",
    options: [
      "Arteria radial",
      "Arteria ulnar",
      "Arteria braquial",
      "Arteria axilar"
    ],
    correctAnswer: 2,
    explanation: "La arteria braquial, continuación de la arteria axilar, irriga principalmente al bíceps braquial a través de ramas musculares. La arteria braquial discurre medialmente al bíceps en el brazo."
  },
  
  {
    id: 10006,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculo se encuentra profundo (posterior) al bíceps braquial?",
    options: [
      "Tríceps braquial",
      "Braquial",
      "Coracobraquial",
      "Deltoides"
    ],
    correctAnswer: 1,
    explanation: "El músculo braquial se encuentra profundo (posterior) al bíceps braquial. El braquial es un flexor puro del codo, mientras que el bíceps tiene función dual (flexión y supinación)."
  },
  
  {
    id: 10007,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa que el bíceps braquial es un músculo biarticular?",
    options: [
      "Tiene dos cabezas",
      "Tiene dos inserciones",
      "Cruza dos articulaciones",
      "Es inervado por dos nervios"
    ],
    correctAnswer: 2,
    explanation: "El bíceps braquial es biarticular porque cruza dos articulaciones: la articulación glenohumeral (hombro) y la articulación del codo. Esto le permite actuar sobre ambas articulaciones."
  },
  
  {
    id: 10008,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la cabeza larga del bíceps braquial?",
    options: [
      "Apófisis coracoides",
      "Tubérculo supraglenoideo",
      "Troquín del húmero",
      "Tuberosidad deltoidea"
    ],
    correctAnswer: 1,
    explanation: "La cabeza larga del bíceps se origina en el tubérculo supraglenoideo de la escápula. Su tendón pasa por el surco intertubercular del húmero y es intraarticular en el hombro."
  },
  
  {
    id: 10009,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿En qué posición del antebrazo el bíceps es más eficiente para la flexión del codo?",
    options: [
      "Pronación completa",
      "Posición neutra",
      "Supinación",
      "No importa la posición"
    ],
    correctAnswer: 2,
    explanation: "El bíceps es más eficiente para la flexión del codo cuando el antebrazo está en supinación. En pronación, el tendón se enrolla alrededor del radio, disminuyendo su ventaja mecánica."
  },
  
  {
    id: 10010,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué es la aponeurosis bicipital (lacertus fibrosus)?",
    options: [
      "El tendón de inserción del bíceps",
      "Una expansión fascial que se extiende hacia la fascia del antebrazo",
      "El origen de la cabeza corta",
      "La vaina sinovial del tendón"
    ],
    correctAnswer: 1,
    explanation: "La aponeurosis bicipital (lacertus fibrosus) es una expansión fascial que se origina del tendón del bíceps y se extiende medialmente para fusionarse con la fascia profunda del antebrazo. Protege la arteria braquial y el nervio mediano."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10011,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué acción realiza la cabeza larga del bíceps sobre la articulación del hombro?",
    options: [
      "Rotación externa",
      "Abducción",
      "Flexión y abducción débil",
      "Extensión"
    ],
    correctAnswer: 2,
    explanation: "La cabeza larga del bíceps actúa como flexor débil y abductor débil del hombro. También contribuye a la estabilidad de la cabeza humeral, especialmente contra desplazamiento superior."
  },
  
  {
    id: 10012,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como sinergistas del bíceps en la flexión del codo?",
    options: [
      "Tríceps y ancóneo",
      "Braquial y braquiorradial",
      "Pronador redondo y supinador",
      "Deltoides y supraespinoso"
    ],
    correctAnswer: 1,
    explanation: "Los sinergistas del bíceps en la flexión del codo son el braquial (flexor puro y más potente) y el braquiorradial (especialmente con el antebrazo en posición neutra). El braquial realiza el 50-70% de la fuerza de flexión."
  },
  
  {
    id: 10013,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué ramas específicas de la arteria braquial irrigan al bíceps?",
    options: [
      "Ramas musculares directas",
      "Arterias circunflejas humerales",
      "Arteria braquial profunda",
      "Arterias colaterales ulnares"
    ],
    correctAnswer: 0,
    explanation: "El bíceps recibe irrigación de ramas musculares directas de la arteria braquial, así como contribuciones de la arteria braquial profunda proximalmente. El drenaje venoso sigue a las venas braquiales."
  },
  
  {
    id: 10014,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿De qué raíces nerviosas se origina el nervio musculocutáneo que inerva al bíceps?",
    options: [
      "C5-C6",
      "C6-C7",
      "C7-C8",
      "C8-T1"
    ],
    correctAnswer: 0,
    explanation: "El nervio musculocutáneo se origina de las raíces C5-C6 del plexo braquial, formándose del fascículo lateral. Inerva los tres músculos del compartimento anterior del brazo: coracobraquial, bíceps y braquial."
  },
  
  {
    id: 10015,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del bíceps braquial?",
    options: [
      "Ausencia de la cabeza larga",
      "Presencia de una tercera cabeza",
      "Inserción doble en el radio",
      "Fusión con el coracobraquial"
    ],
    correctAnswer: 1,
    explanation: "La presencia de una tercera cabeza (bíceps tríceps) es la variante más común, ocurriendo en 10-20% de la población. Generalmente se origina del húmero y se inserta con el tendón principal."
  },
  
  {
    id: 10016,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa específicamente la integridad del tendón del bíceps?",
    options: [
      "Test de Neer",
      "Test de Speed",
      "Test de Hawkins",
      "Test de Adson"
    ],
    correctAnswer: 1,
    explanation: "El test de Speed evalúa la tendinitis de la cabeza larga del bíceps. Se realiza con el hombro flexionado a 90°, codo extendido y antebrazo supinado. El dolor en el surco bicipital con resistencia es positivo."
  },
  
  {
    id: 10017,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué estructura embrionaria se desarrolla el bíceps braquial?",
    options: [
      "Somitas cervicales",
      "Mesénquima del miembro superior",
      "Cresta neural",
      "Placa lateral del mesodermo"
    ],
    correctAnswer: 1,
    explanation: "El bíceps braquial se desarrolla del mesénquima del miembro superior alrededor de la 5-6 semana de gestación. Los músculos del compartimento anterior del brazo derivan de la masa flexora ventral."
  },
  
  {
    id: 10018,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué tipo de fibras musculares predominan en el bíceps braquial?",
    options: [
      "Tipo I (lentas oxidativas)",
      "Tipo IIa (rápidas oxidativas-glucolíticas)",
      "Tipo IIb (rápidas glucolíticas)",
      "Distribución igual de todos los tipos"
    ],
    correctAnswer: 1,
    explanation: "El bíceps braquial tiene predominio de fibras tipo IIa (rápidas oxidativas-glucolíticas), adaptadas para movimientos de potencia y resistencia moderada. La proporción exacta varía con el entrenamiento."
  },
  
  {
    id: 10019,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura anatómica pasa entre las dos cabezas del bíceps en su origen?",
    options: [
      "Nervio radial",
      "Arteria braquial",
      "Tendón del pectoral mayor",
      "Nervio musculocutáneo"
    ],
    correctAnswer: 3,
    explanation: "El nervio musculocutáneo perfora el músculo coracobraquial y luego pasa entre las dos cabezas del bíceps en la parte proximal del brazo antes de inervar el músculo y continuar como nervio cutáneo lateral del antebrazo."
  },
  
  {
    id: 10020,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el bíceps es menos eficiente para la supinación cuando el codo está completamente extendido?",
    options: [
      "Por la longitud del brazo de palanca",
      "Por la posición del nervio",
      "Por el ángulo de tracción del tendón",
      "Por la contracción del tríceps"
    ],
    correctAnswer: 2,
    explanation: "Con el codo extendido, el ángulo de tracción del tendón del bíceps sobre el radio es menos favorable, disminuyendo su eficiencia para la supinación. La máxima eficiencia de supinación ocurre con el codo flexionado a 90°."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10021,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente de 45 años presenta 'signo de Popeye' tras levantar objeto pesado. ¿Qué estructura se rompió?",
    options: [
      "Tendón distal del bíceps",
      "Tendón de la cabeza larga del bíceps",
      "Tendón de la cabeza corta del bíceps",
      "Músculo braquial"
    ],
    correctAnswer: 1,
    explanation: "El 'signo de Popeye' (abultamiento del bíceps en reposo) indica ruptura del tendón de la cabeza larga del bíceps. Es más común en pacientes >40 años con tendinopatía crónica. La función se preserva relativamente porque la cabeza corta permanece intacta."
  },
  
  {
    id: 10022,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con pérdida de flexión del codo y supinación después de trauma. Hook test negativo. ¿Diagnóstico?",
    options: [
      "Ruptura del tendón distal del bíceps",
      "Lesión del nervio musculocutáneo",
      "Fractura de radio proximal",
      "Ruptura del braquial"
    ],
    correctAnswer: 0,
    explanation: "La ruptura completa del tendón distal del bíceps causa pérdida de fuerza en flexión del codo (50%) y supinación (70%). El hook test es diagnóstico: la incapacidad de 'enganchar' el tendón distal indica ruptura completa. Requiere reparación quirúrgica urgente para restaurar función."
  },
  
  {
    id: 10023,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Cuál es el abordaje quirúrgico estándar para reparar una ruptura del tendón distal del bíceps?",
    options: [
      "Abordaje posterior",
      "Abordaje anterior único (Henry)",
      "Abordaje doble (anterior y posterior)",
      "Abordaje medial"
    ],
    correctAnswer: 1,
    explanation: "El abordaje de Henry modificado (anterior) es el estándar para reparación del tendón distal del bíceps. Se realiza reinserción con anclas de sutura o técnica de botón. La reparación temprana (<3 semanas) tiene mejor pronóstico. Complicaciones incluyen osificación heterotópica y lesión del nervio interóseo posterior."
  },
  
  {
    id: 10024,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM de hombro, ¿qué hallazgo sugiere tendinosis de la cabeza larga del bíceps?",
    options: [
      "Señal normal en T1 y T2",
      "Aumento de señal intratendinosa en T2 con engrosamiento",
      "Hiposeñal en todas las secuencias",
      "Realce periférico con contraste"
    ],
    correctAnswer: 1,
    explanation: "La tendinosis del bíceps en RM muestra: engrosamiento del tendón (>6mm), aumento de señal intratendinosa en T2/STIR (degeneración mixoide), y líquido en la vaina tendinosa. La tenosinovitis asociada es común. La ruptura completa muestra retracción y ausencia del tendón en el surco."
  },
  
  {
    id: 10025,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué síndrome de atrapamiento nervioso puede simular tendinitis del bíceps?",
    options: [
      "Síndrome del túnel carpiano",
      "Síndrome del pronador redondo",
      "Síndrome del nervio interóseo anterior",
      "Neuropatía del musculocutáneo"
    ],
    correctAnswer: 3,
    explanation: "La neuropatía del nervio musculocutáneo puede causar dolor en la región anterior del brazo similar a tendinitis del bíceps, además de debilidad en flexión del codo. Causas incluyen: trauma, lipomas, fibrosis. El diagnóstico se confirma con electromiografía mostrando denervación del bíceps, braquial y coracobraquial."
  },
  
  {
    id: 10026,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Atleta con dolor anterior de codo al realizar curl con mancuerna. Ecografía muestra engrosamiento de bursa bicipitoradial. Diagnóstico:",
    options: [
      "Tendinitis de inserción del bíceps",
      "Bursitis bicipitoradial",
      "Síndrome de atrapamiento del nervio radial",
      "Epicondilitis medial"
    ],
    correctAnswer: 1,
    explanation: "La bursitis bicipitoradial ocurre entre el tendón distal del bíceps y la tuberosidad del radio. Común en atletas que realizan movimientos repetitivos de pronación-supinación. Se trata con reposo, AINEs, fisioterapia y ocasionalmente infiltración con corticoides. La cirugía es rara."
  },
  
  {
    id: 10027,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se prefiere para tenodesis de la cabeza larga del bíceps en tendinitis refractaria?",
    options: [
      "Tenotomía simple",
      "Tenodesis suprapectoral",
      "Tenodesis subpectoral",
      "Transferencia tendinosa"
    ],
    correctAnswer: 2,
    explanation: "La tenodesis subpectoral (en el surco bicipital distal al pectoral mayor) es preferida en pacientes jóvenes/activos con tendinitis refractaria de cabeza larga del bíceps. Reduce el riesgo de 'signo de Popeye' y dolor residual comparado con tenotomía simple. La tenotomía se reserva para pacientes >60 años o baja demanda funcional."
  },
  
  {
    id: 10028,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con ruptura de cabeza larga del bíceps no operada. ¿Qué déficit funcional persistirá?",
    options: [
      "Pérdida completa de flexión del codo",
      "Pérdida de 5-10% fuerza de flexión, 10-20% de supinación",
      "Imposibilidad de levantar el brazo",
      "Pérdida total de supinación"
    ],
    correctAnswer: 1,
    explanation: "La ruptura aislada de cabeza larga del bíceps causa déficit funcional mínimo: 5-10% pérdida de fuerza de flexión y 10-20% de supinación. La cabeza corta y el braquial compensan. Muchos pacientes >60 años se manejan conservadoramente con buenos resultados funcionales. El déficit estético (signo de Popeye) puede ser la principal queja."
  },
  
  {
    id: 10029,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía dinámica, ¿qué maniobra evalúa la subluxación del tendón de la cabeza larga del bíceps?",
    options: [
      "Flexión pasiva del codo",
      "Rotación interna-externa del hombro",
      "Abducción del hombro",
      "Supinación-pronación del antebrazo"
    ],
    correctAnswer: 1,
    explanation: "La ecografía dinámica con rotación interna-externa del hombro evalúa la estabilidad del tendón de la cabeza larga en el surco intertubercular. La subluxación/luxación indica lesión del ligamento coracohumeral, polea del bíceps, o subescapular. Se correlaciona con dolor anterior del hombro e inestabilidad."
  },
  
  {
    id: 10030,
    muscle: 'biceps_braquial',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Levantador de pesas presenta ruptura bilateral de tendones distales del bíceps. ¿Qué factor de riesgo es más probable?",
    options: [
      "Deficiencia de vitamina D",
      "Uso de esteroides anabólicos",
      "Edad >60 años",
      "Diabetes mellitus"
    ],
    correctAnswer: 1,
    explanation: "Las rupturas bilaterales simultáneas de tendones distales del bíceps son raras pero asociadas al uso de esteroides anabólicos. Los esteroides causan degeneración tendinosa mientras aumentan la fuerza muscular, creando desequilibrio. También se asocian con uso de fluoroquinolonas y enfermedad renal crónica. Requieren reparación quirúrgica bilateral urgente."
  }
  
];

// Total: 30 preguntas (10 básicas + 10 generales + 10 complejas)
